module.exports = __webpack_public_path__ + "img/sushioben.942d6711.jpg";